<script lang="ts" setup>
  import { computed, ref, toRefs } from 'vue'
  import { DateTime } from 'luxon'

  interface Props {
    label?: string
    required?: boolean
    tabindex?: string
    nullOnEmpty?: boolean
    min?: DateTime<true>
    max?: DateTime<true>
    invalid?: boolean
    type?: 'datetime-local' | 'date'
    disabled?: boolean
  }

  const emit = defineEmits<{
    focus: [Event]
    tabUp: [KeyboardEvent]
    blur: [FocusEvent]
  }>()
  const props = withDefaults(defineProps<Props>(), { type: 'datetime-local', label: undefined, required: undefined, tabindex: undefined, nullOnEmpty: undefined, min: undefined, max: undefined, invalid: undefined, disabled: undefined })
  const { label, max, min, required, type, disabled } = toRefs(props)
  const value = defineModel<DateTime<true> | null | undefined>({ required: true })

  const input = computed<string | undefined | null>({
    get: (): string | undefined | null => {
      if (!value.value) return undefined
      if (type.value == 'date') return value.value.toISODate()
      else return value.value.toISO({ includeOffset: false, suppressMilliseconds: true })
    },
    set: (v: string | undefined | null) => {
      if (!v) {
        value.value = props.nullOnEmpty ? null : undefined
        return
      }
      let dt = DateTime.fromISO(v)
      if (dt.isValid) {
        if (type.value == 'date') dt = dt.set({ hour: 0, minute: 0 })
        dt = dt.set({ second: 0, millisecond: 0 })
        value.value = dt
      } else value.value = props.nullOnEmpty ? null : undefined
    }
  })

  function onKeyUp(e: KeyboardEvent) {
    if (e.code == 'Tab') {
      emit('tabUp', e)
    }
  }

  const refInput = ref(null)

  function selectTime() {

  }

  defineExpose({ selectTime })

  const onBlur = (e: FocusEvent) => {
    if (min.value && input.value && +min.value > +DateTime.fromISO(input.value))
      isMsgVisible.value = true

    emit('blur', e)
  }

  const onFocus = (e: Event) => {
    emit('focus', e)
    isMsgVisible.value = false
  }

  const isMsgVisible = ref(false)
</script>

<template>
  <div class="form-group">
    <FloatLabel variant="on">
      <label v-if="label">{{ label }}</label>
      <InputText
        ref="refInput"
        v-model="input"
        :class="[{ '!border-2 !border-red-500': invalid }, {'p-inputwrapper-filled': !!label}]"
        :disabled="disabled"
        :max="max ? (type == 'date' ? max.toISODate() : max.toISO({ includeOffset: false, suppressMilliseconds: true })) : undefined"
        :min="min ? (type == 'date' ? min.toISODate() : min.toISO({ includeOffset: false, suppressMilliseconds: true })) : undefined"
        :required="required"
        :tabindex="tabindex"
        :type="type"
        class="w-full titrop-input"
        @blur="onBlur"
        @focus="onFocus"
        @keyup="onKeyUp" />
    </FloatLabel>
    <Message v-if="min && isMsgVisible" size="small" severity="warn">
      Minimal mögliches Datum: {{ min.toFormat('dd.LL.yyyy') }}
    </Message>
  </div>
</template>

<style scoped></style>
